// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2tT4W","buttons":"SendReceipts_buttons__1NnPj","email":"SendReceipts_email__3cHXt","bookApptTitle":"SendReceipts_bookApptTitle__3opeq"};